// extracted by mini-css-extract-plugin
export default {"products":"ProductsList_products__6wK0p","productsList":"ProductsList_productsList__5kh5G","error":"ProductsList_error__EfqB2"};